export default function LessonSection() {
  return (
    <section id="lesson" className="pf-section pf-lesson">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">LESSON</p>
        <h2 className="pf-section__title">彩雲書道教室</h2>
      </div>

      <div className="pf-lesson__card">
        <p className="pf-lesson__text">
          個別指導・習字教室を開催しています。形式はオンライン、または浜松市にて。
          経験豊富な書家による丁寧な指導で、初心者の方も安心してご参加いただけます。
        </p>
        <p className="pf-lesson__note">料金・日程など詳細はお問い合わせください。</p>
        <a className="pf-lesson__cta" href="#contact">CONTACTへ</a>
      </div>
    </section>
  );
}
